import { render, staticRenderFns } from "./AccountHolderExpenseRelationships.vue?vue&type=template&id=66337174&scoped=true"
import script from "./AccountHolderExpenseRelationships.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseRelationships.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66337174",
  null
  
)

export default component.exports